<template>
  <div class="bg-ul-orange-400 text-ul-orange-50 relative flex flex-col items-center justify-center overflow-hidden">
    <QuarterCircle :radius="64" direction="southwest" class="absolute top-0 right-0" />
    <HalfCircle :radius="64" direction="east" class="absolute left-0" />

    <div class="z-1 my-8 flex w-full flex-row justify-around px-2 sm:my-20 md:max-w-(--breakpoint-md)">
      <a
        v-for="link in socialMediaLinks"
        :key="link.href"
        :href="link.href"
        target="_blank"
        rel="noopener noreferrer"
        :title="'UL på ' + link.name"
      >
        <Icon :icon="link.icon" class="hover:text-opacity-75 h-10" />
      </a>
    </div>
    <div class="border-ul-orange-50 z-1 mb-8 w-32 border-t border-solid sm:mb-12" />
    <p class="z-1">Festivalen arrangeres av:</p>
    <div class="z-1 mt-4 flex flex-col sm:mt-12 sm:flex-row">
      <a
        v-for="organizer in organizers"
        :key="organizer.name"
        class="border-ul-orange-50 bg-ul-orange-400 bg-opacity-40 hover:bg-opacity-75 mx-6 mb-3 border-2 border-solid px-16 py-4 text-center font-bold opacity-75 duration-300 hover:opacity-100 sm:mb-0"
        :href="organizer.link"
        rel="noopener noreferrer"
      >
        {{ organizer.name }}
      </a>
    </div>
    <div class="z-1 m-12 flex flex-col items-center justify-center text-center">
      <p class="italic">&copy; Misjonssambandet ung</p>
      <p class="text-xs font-light italic">
        Nettsiden vedlikeholdes av
        <a href="https://vitterso.net" target="_blank" class="underline underline-offset-[3px]">Sebastian Vittersø</a>.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from './Icon.vue'
import HalfCircle from './circles/HalfCircle.vue'
import QuarterCircle from './circles/QuarterCircle.vue'
import type { IconKey } from './icons'

const organizers = [
  {
    name: 'Misjonssambandet ung',
    link: 'https://nlm.no/nlmung/',
  },
  {
    name: ' ImF-UNG',
    link: 'https://imf-ung.no/',
  },
]

const socialMediaLinks = [
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/unglandsmote/',
    icon: 'facebook',
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/unglandsmote/',
    icon: 'instagram',
  },
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/channel/UCMZYb2fzkSCpFaLlp8gZTQw',
    icon: 'youtube',
  },
  {
    name: 'TikTok',
    href: 'https://www.tiktok.com/@unglandsmote',
    icon: 'tiktok',
  },
  {
    name: 'Podcast',
    href: 'https://open.spotify.com/show/6Gq42YIUXB0ECLACSl8OUd?si=3pnTcpACR7O_5p6YUojUqQ',
    icon: 'podcast',
  },
] satisfies {
  name: string
  href: string
  icon: IconKey
}[]
</script>

<style lang="scss"></style>
